import { PayloadAction } from '@reduxjs/toolkit'
import { call, put, takeLatest } from 'redux-saga/effects'

import rocketChatModel from '@/core/models/rocket-chat.model'

import {
  login as loginAction,
  createConsultationChatGroup as createConsultationChatGroupAction,
  createConsultationChatGroupSuccess as createConsultationChatGroupSuccessAction,
  createConsultationChatGroupFailure as createConsultationChatGroupFailureAction,
  getConsultationChatGroup as getConsultationChatGroupAction,
  getConsultationChatGroupSuccess as getConsultationChatGroupSuccessAction,
  getConsultationChatGroupFailure as getConsultationChatGroupFailureAction,
  createEstablishmentChatChannel as createEstablishmentChatChannelAction,
  createEstablishmentChatChannelSuccess as createEstablishmentChatChannelSuccessAction,
  createEstablishmentChatChannelFailure as createEstablishmentChatChannelFailureAction,
  createStaffChatDirectMessage as createStaffChatDirectMessageAction,
  createStaffChatDirectMessageSuccess as createStaffChatDirectMessageSuccessAction,
  createStaffChatDirectMessageFailure as createStaffChatDirectMessageFailureAction,
} from '@/redux/reducers/rocket-chat.reducer'

import { handleError } from '@/utils/errors'

function* login(action: PayloadAction<HTMLIFrameElement>) {
  const iframeElement = action.payload
  try {
    const loginToken: string = yield call(rocketChatModel.login)
    iframeElement.contentWindow?.postMessage({
      externalCommand: 'login-with-token',
      token: loginToken,
    }, '*')
  } catch {
    iframeElement.contentWindow?.postMessage({
      externalCommand: 'call-custom-oauth-login',
      service: 'keycloaklocal'
    }, '*')
  }
}

function* createConsultationChatGroup(action: PayloadAction<{ consultationId: string, groupName: string, members: string[], isEmbeddedLayout?: boolean }>) {
  try {
    const { groupName, consultationId, members, isEmbeddedLayout } = action.payload
    const iframeUrl: string = yield call(rocketChatModel.createGroup, groupName, members, isEmbeddedLayout)
    yield put(createConsultationChatGroupSuccessAction({ consultationId, iframeUrl }))
  } catch (e) {
    yield put(createConsultationChatGroupFailureAction(handleError(e)))
  }
}

function* getConsultationChatGroup(action: PayloadAction<{ consultationId: string, groupName: string, isEmbeddedLayout?: boolean }>) {
  try {
    const { groupName, consultationId, isEmbeddedLayout } = action.payload
    const iframeUrl: string = yield call(rocketChatModel.getGroup, { groupName }, isEmbeddedLayout)
    yield put(getConsultationChatGroupSuccessAction({ consultationId, iframeUrl }))
  } catch (e) {
    yield put(getConsultationChatGroupFailureAction(handleError(e)))
  }
}

function* createEstablishmentChatChannel(action: PayloadAction<{ channelName: string; establishmentId: string; isEmbeddedLayout?: boolean }>) {
  try {
    const { channelName, establishmentId, isEmbeddedLayout } = action.payload
    const iframeUrl: string = yield call(rocketChatModel.createChannel, channelName, isEmbeddedLayout)
    yield put(createEstablishmentChatChannelSuccessAction({ establishmentId, iframeUrl }))
  } catch (e) {
    yield put(createEstablishmentChatChannelFailureAction(handleError(e)))
  }
}


function* createStaffChatDirectMessage(action: PayloadAction<{ staffId: string, username: string, isEmbeddedLayout?: boolean }>) {
  try {
    const { staffId, username, isEmbeddedLayout } = action.payload
    const iframeUrl: string = yield call(rocketChatModel.createDirectMessage, username, isEmbeddedLayout)
    yield put(createStaffChatDirectMessageSuccessAction({ staffId, iframeUrl }))
  } catch (e) {
    yield put(createStaffChatDirectMessageFailureAction(handleError(e)))
  }
}

const sagas = [
  takeLatest(createConsultationChatGroupAction.type, createConsultationChatGroup),
  takeLatest(getConsultationChatGroupAction.type, getConsultationChatGroup),
  takeLatest(createEstablishmentChatChannelAction.type, createEstablishmentChatChannel),
  takeLatest(createStaffChatDirectMessageAction.type, createStaffChatDirectMessage),
  takeLatest(loginAction.type, login),
]

export default sagas
